// extracted by mini-css-extract-plugin
export var animationAbsolute = "_15-q";
export var animationRelative = "_15-p";
export var backdropBlur = "_15-0";
export var detailLabelCell = "_15-12";
export var detailTable = "_15-11";
export var detailValueCell = "_15-13";
export var docIconBox = "_15-1d";
export var docIconBoxMd = "_15-1f";
export var docIconBoxSm = "_15-1e";
export var docTypeRow = "_15-16";
export var docTypeRowInner = "_15-17";
export var dropdownMatchDatePicker = "_15-3";
export var evidenceCardContent = "_15-1c";
export var fileUploadSpin = "_15-j";
export var gorgiasOpenButton = "_15-15 _15-d";
export var gorgiasTicketCard = "_15-14";
export var heroModalFooterButton = "_15-18";
export var hiddenContainer = "_15-o";
export var iconPrimary = "_15-1g";
export var iconQuaternary = "_15-1i";
export var iconTertiary = "_15-1h";
export var integrationCard = "_15-1";
export var integrationLogoBox = "_15-2";
export var mainColumnSticky = "_15-1b";
export var maxWidthContainer = "_15-19";
export var modalContentBody = "_15-a";
export var modalHeaderImage = "_15-5";
export var modalImageLabel = "_15-7";
export var modalImageOverlay = "_15-6";
export var modalImageSubtitle = "_15-9";
export var modalImageTitle = "_15-8";
export var modalImageWrapper = "_15-4";
export var modalStickyFooter = "_15-b";
export var removeButton = "_15-e";
export var sidebarColumn = "_15-1a";
export var spinner = "_15-i";
export var timelineLine = "_15-y";
export var timelineLineBlack = "_15-10 _15-y";
export var timelineLineGray = "_15-z _15-y";
export var timelineLineHeight = "_15-x";
export var tlDotActivate = "_15-u";
export var tlDotActivateAnim = "_15-t";
export var tlDotHide = "_15-s";
export var tlDotHideAnim = "_15-r";
export var tlLineActivate = "_15-w";
export var tlLineActivateAnim = "_15-v";
export var uploadHint = "_15-n";
export var uploadIconBox = "_15-k";
export var uploadLabel = "_15-m";
export var uploadText = "_15-l";
export var uploadZone = "_15-f";
export var uploadZoneCursorDefault = "_15-h";
export var uploadZoneCursorPointer = "_15-g";
export var uploadedFileRow = "_15-c";
export var viewButton = "_15-d";